import { Box, polymorphicFactory, Typography } from '@kohler-dsm-library/kohler-core';
import { ArrowRightBoldIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import classes from './index.module.scss';

export const OverlayMenuItem = polymorphicFactory(
  (props, ref) => {
    const { className, title, showArrow = true, component = 'button', ...rest } = props;

    return (
      <Box
        ref={ref}
        className={clsx(className, 'kohler-overlay-menu-item', classes.overlayMenuItem)}
        component={component}
        type={component === 'button' ? 'button' : undefined}
        textColor="var(--content-primary)"
        {...rest}
      >
        <Typography component="span" size="navigation-m" textColor="var(--content-primary)">
          {title}
        </Typography>
        {showArrow && <ArrowRightBoldIcon size="xSmall" withBoundingBox={false} />}
      </Box>
    );
  }
);
